/**
 * Sorts given array of widths so groups of width fit best in a row
 *
 *
 * @param width width of container
 * @param sizes array of widths
 * @returns array of indexes
 */
export const fitBest = (width: number, widths: number[]) => {
  if (!widths.length) return []
  if (widths.length === 1) return [0]
  const wData = widths.map((w, i) => ({ index: i, width: w })).sort((a, b) => b.width - a.width)
  const minWidth = wData.at(-1)!.width
  if (width <= minWidth) return new Array(widths.length).fill(0).map((_x, i) => i)
  const groups = [[wData.shift()!]]
  while (wData.length) {
    const lastGroup = groups.at(-1)!
    const groupLength = lastGroup.reduce<number>((c, x) => c + x.width, 0)
    const remainingSpace = width - groupLength
    if (remainingSpace < minWidth) {
      groups.push([])
      continue
    }
    const bestFitIndex = wData.findIndex(e => e.width <= remainingSpace)
    lastGroup.push(wData.splice(bestFitIndex, 1)[0])
  }
  const flatten = groups.reduce<number[]>((c, x) => [...c, ...x.map(x => x.index)], [])
  return flatten
}
